import { render, staticRenderFns } from "./seat-details-modal.vue?vue&type=template&id=0c6336d4&scoped=true"
import script from "./seat-details-modal.vue?vue&type=script&lang=js"
export * from "./seat-details-modal.vue?vue&type=script&lang=js"
import style0 from "./seat-details-modal.vue?vue&type=style&index=0&id=0c6336d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6336d4",
  null
  
)

export default component.exports